import { GenericMedicalList } from "./GenericMedicalList";

const APPROACHES = [
  "Open", "Laparoscopic", "Robotic", "Endoscopic", "Percutaneous", "Minimally Invasive",
];
const ANESTHESIA = ["General", "Regional", "Local", "MAC (Monitored)", "Spinal", "Epidural"];
const OUTCOMES = ["Successful", "Successful with Complications", "Aborted", "Ongoing"];

const DEFAULT = { procedure_name: "", cpt_code: "", procedure_date: "", surgeon: "",
                  facility: "", approach: "", anesthesia_type: "", outcome: "Successful",
                  complications: "", indication: "", notes: "" };

const COLUMNS = [
  { key: "procedure_date", label: "Date", format: "date" },
  { key: "procedure_name", label: "Procedure" },
  { key: "surgeon", label: "Surgeon" },
  { key: "facility", label: "Facility" },
  { key: "outcome", label: "Outcome", format: "chip" },
];

const FIELDS = [
  { key: "procedure_name", label: "Procedure Name", required: true, span: 2 },
  { key: "cpt_code", label: "CPT Code" },
  { key: "procedure_date", label: "Date of Procedure", type: "date", required: true },
  { key: "surgeon", label: "Surgeon" },
  { key: "facility", label: "Facility" },
  { key: "approach", label: "Surgical Approach", type: "select", options: APPROACHES },
  { key: "anesthesia_type", label: "Anesthesia", type: "select", options: ANESTHESIA },
  { key: "outcome", label: "Outcome", type: "select", options: OUTCOMES, required: true },
  { key: "indication", label: "Indication or Reason", type: "textarea", span: 2 },
  { key: "complications", label: "Complications (if any)", type: "textarea", span: 2 },
  { key: "notes", label: "Notes", type: "textarea", span: 2 },
];

export default function SurgicalHistory({ client }) {
  return (
    <GenericMedicalList
      client={client}
      title="Surgical History"
      subtitle="Past procedures with surgeon, facility, and complications."
      endpointList={(cid) => `/clients/${cid}/surgical-history`}
      endpointCreate={(cid) => `/clients/${cid}/surgical-history`}
      endpointUpdate={(id) => `/surgical-history/${id}`}
      endpointDelete={(id) => `/surgical-history/${id}`}
      columns={COLUMNS}
      formFields={FIELDS}
      defaultForm={DEFAULT}
      testPrefix="surgical-history"
      emptyText="No surgical history recorded"
    />
  );
}
